import React, { Component } from 'react';
import './App.css';
import Routes from './router/Routes'

class App extends Component {
  render() {
    return (
      <Routes />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js